import http from '../http'
const API_URL = 'reclassification_scores/puntation'

class NewScores {

  async classificationCompanie(data) {
    const response = await http(`${API_URL}`, 'POST', data)
    return response
  }

  async scores(data) {
    const response = await http(`${API_URL}/scores`, 'POST', data)
    return response
  }

  async modalClassification(data) {
    const response = await http(`${API_URL}/modalClassification`, 'POST', data)
    return response
  }

  async calculateScores(data) {
    const response = await http(`${API_URL}/calculateScores`, 'POST', data)
    return response
  }

}

export default new NewScores()

